/* ==========================================================================
   mammisi — storefront behaviour
   One JS breakpoint: 1000px. Everything else is fluid CSS.
   ========================================================================== */
(function () {
  'use strict';

  var NARROW = 1000;
  var EASE = 'cubic-bezier(.2,.7,.2,1)';
  var CFG = window.MammisiConfig || {};
  var T = (window.MammisiI18n || {});

  /* ------------------------------------------------------------ helpers */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function on(el, ev, fn, opt) { if (el) el.addEventListener(ev, fn, opt); }
  function isNarrow() { return window.innerWidth < NARROW; }

  /* Format exactly as Liquid's `money` filter does, using the shop's own
     money_format, so JS-computed prices match server-rendered ones. */
  function group(num, thousands, decimal) {
    var parts = num.split('.');
    var int = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return parts[1] && decimal ? int + decimal + parts[1] : int;
  }

  function money(cents) {
    var fmt = CFG.moneyFormat || '{{amount}}';
    var v = (cents || 0) / 100;
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, key) {
      switch (key) {
        case 'amount': return group(v.toFixed(2), ',', '.');
        case 'amount_no_decimals': return group(Math.round(v).toString(), ',', '');
        case 'amount_with_comma_separator': return group(v.toFixed(2), '.', ',');
        case 'amount_no_decimals_with_comma_separator': return group(Math.round(v).toString(), '.', ',');
        case 'amount_with_apostrophe_separator': return group(v.toFixed(2), "'", '.');
        case 'amount_no_decimals_with_space_separator': return group(Math.round(v).toString(), ' ', '');
        case 'amount_with_space_separator': return group(v.toFixed(2), ' ', ',');
        default: return '';
      }
    }).replace(/<[^>]*>/g, '').trim();
  }
  function isAr() { return document.documentElement.getAttribute('dir') === 'rtl'; }
  function t(key, fallback) { return (isAr() && T[key]) ? T[key] : fallback; }

  /* --------------------------------------------------------- 1. reveals */
  var io = null;
  function initReveal() {
    var items = $$('[data-reveal]:not([data-seen])');
    if (!items.length) return;
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          var el = e.target;
          var d = parseInt(el.getAttribute('data-reveal-delay') || '0', 10);
          setTimeout(function () { el.classList.add('mm-in'); }, d);
          io.unobserve(el);
        });
      }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });
    }
    items.forEach(function (el) {
      el.setAttribute('data-seen', '1');
      io.observe(el);
    });
  }

  /* timeline connector draws once on entry (wide only) */
  function initTimeline() {
    var tl = $('.mm-timeline');
    if (!tl || tl.hasAttribute('data-tl-seen')) return;
    tl.setAttribute('data-tl-seen', '1');
    var tio = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { tl.classList.add('mm-drawn'); tio.unobserve(e.target); }
      });
    }, { threshold: 0.2 });
    tio.observe(tl);
  }

  /* -------------------------------------------------------- 2. parallax */
  var parallaxEls = [];
  var heroLayer = null;
  function collectParallax() {
    parallaxEls = $$('[data-parallax]');
    heroLayer = $('.mm-hero__layer');
  }
  function parallax() {
    if (!parallaxEls.length && !heroLayer) return;
    var h = window.innerHeight;
    parallaxEls.forEach(function (el) {
      var r = el.getBoundingClientRect();
      var f = parseFloat(el.getAttribute('data-parallax'));
      var p = (r.top + r.height / 2 - h / 2) / h;
      el.style.translate = '0 ' + (p * f * 160).toFixed(1) + 'px';
    });
    if (heroLayer) {
      heroLayer.style.translate = '0 ' + Math.min(window.scrollY * 0.14, 120).toFixed(1) + 'px';
    }
  }

  /* --------------------------------------------- 3. viewport flag (140ms) */
  var rz = null;
  function syncNarrow() {
    document.body.classList.toggle('mm-narrow', isNarrow());
    document.body.classList.toggle('mm-wide', !isNarrow());
    syncHeroSource();
  }
  on(window, 'resize', function () {
    if (rz) return;
    rz = setTimeout(function () { rz = null; syncNarrow(); }, 140);
  });

  /* ------------------------------------------------------------ 4. hero */
  var slide = 0, slideTimer = null, pauseTimer = null, advancing = false;
  var HERO_RATE = 0.75;      // raw clips read better a little under speed
  var HERO_FADE = 0.2;       // seconds of overlap between one clip and the next
  function heroImgs() { return $$('.mm-hero__img'); }

  /* Rate belongs to the footage, not the player: three unedited clips wanted
     slowing down, a piece already cut to time does not. The section says which. */
  var rateCache = null;
  function heroRate() {
    if (rateCache === null) {
      var hero = $('.mm-hero');
      var r = hero ? parseFloat(hero.getAttribute('data-rate')) : NaN;
      rateCache = r > 0 ? r : HERO_RATE;
    }
    return rateCache;
  }

  var reduceMotion = window.matchMedia
    && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Wide screens show a single still and no motion. Narrow plays the three
     clips in turn: each advances on its own `ended`, so pacing follows the
     footage rather than a guessed interval. The timer is only a fallback for
     when playback never starts — a blocked autoplay, or a still standing in
     for a clip — and is cleared every time we advance. */
  function syncHeroSource() {
    var hero = $('.mm-hero');
    if (!hero) return;

    if (!isNarrow()) {
      clearTimeout(slideTimer); slideTimer = null;
      heroImgs().forEach(function (el) { if (el.pause) el.pause(); });
      showWide();
    } else {
      clearTimeout(wideTimer); wideTimer = null;
      wideVids().forEach(function (el) { if (el.pause) el.pause(); });
      if (heroImgs().length) showSlide();
    }
  }

  /* ---- the wide set: same three-in-turn idea, but cut, not dissolved ----
     Separate from the narrow machinery on purpose. There is no overlap to
     manage, so each clip simply runs to its last frame and `ended` hands over;
     the outgoing one is paused at once rather than played through a fade. */
  var wide = 0, wideTimer = null;
  function wideVids() { return $$('.mm-hero__wide'); }

  function showWide() {
    var vids = wideVids();
    if (!vids.length || isNarrow()) return;
    vids.forEach(function (el, i) {
      var on = i === wide;
      el.style.opacity = on ? '1' : '0';
      if (reduceMotion) return;
      if (on) {
        try { el.currentTime = 0; var p = el.play(); if (p && p.catch) p.catch(function () {}); } catch (e) {}
      } else {
        el.pause();
      }
    });
    clearTimeout(wideTimer);
    var cur = vids[wide];
    wideTimer = setTimeout(cycleWide, cur && cur.duration ? cur.duration * 1000 + 1500 : 6000);
  }

  function cycleWide() {
    var vids = wideVids();
    if (vids.length < 2 || isNarrow()) return;
    wide = (wide + 1) % vids.length;
    showWide();
  }

  /* Autoplay can be refused — iOS low-power mode, a data-saver setting, a
     browser that wants a gesture first. The play() calls all swallow their
     rejection, so a refusal used to be permanent: the poster sat there with
     the browser's own play button drawn over it. This retries the moment the
     visitor does anything at all, and gives up listening once something plays. */
  function nudgePlay() {
    var tried = false;
    function go() {
      if (tried) return;
      var live = (isNarrow() ? heroImgs() : wideVids()).filter(function (el) {
        return el.tagName === 'VIDEO' && (el.style.opacity === '1' || el.style.opacity === '');
      });
      live.forEach(function (el) {
        el.muted = true;                     // a gesture does not excuse sound
        var p = el.play();
        if (p && p.then) p.then(function () { tried = true; off(); }).catch(function () {});
      });
    }
    function off() {
      ['touchstart', 'pointerdown', 'click', 'scroll', 'keydown'].forEach(function (t) {
        document.removeEventListener(t, go, true);
      });
    }
    ['touchstart', 'pointerdown', 'click', 'scroll', 'keydown'].forEach(function (t) {
      document.addEventListener(t, go, { capture: true, passive: true });
    });
    // and once more when the tab comes back, which is its own kind of refusal
    on(document, 'visibilitychange', function () { if (!document.hidden) go(); });
  }

  function initHeroWide() {
    wideVids().forEach(function (el, i) {
      el.muted = true;                       // iOS will not autoplay otherwise
      on(el, 'ended', function () {
        if (isNarrow() || wideVids()[wide] !== el) return;
        cycleWide();
      });
    });
  }

  function showSlide() {
    advancing = false;
    heroImgs().forEach(function (el, i) {
      var on = i === slide;
      el.style.opacity = on ? '1' : '0';
      if (el.tagName === 'VIDEO' && on && !reduceMotion) {
        el.playbackRate = heroRate();
        try { el.currentTime = 0; var p = el.play(); if (p && p.catch) p.catch(function () {}); } catch (e) {}
      }
      // the outgoing clip keeps playing through the fade — pausing it here is
      // what made the hero look like it stopped dead between slides
    });
    clearTimeout(pauseTimer);
    pauseTimer = setTimeout(function () {
      heroImgs().forEach(function (el, i) {
        if (i !== slide && el.tagName === 'VIDEO') el.pause();
      });
    }, HERO_FADE * 1000 + 250);
    var dots = $('.mm-hero__dots');
    if (dots) {
      Array.prototype.forEach.call(dots.children, function (d, i) {
        d.classList.toggle('mm-on', i === slide);
      });
    }
    clearTimeout(slideTimer);
    slideTimer = setTimeout(cycleHero, fallbackMs());   // fallback only
  }

  /* Only a safety net for when playback never starts — a blocked autoplay, or
     a still standing in for a clip. Timed off the clip itself, so a long piece
     of footage is never cut short by a guessed interval. */
  function fallbackMs() {
    var el = heroImgs()[slide];
    if (el && el.tagName === 'VIDEO' && el.duration) {
      return (el.duration / heroRate()) * 1000 + 2000;
    }
    return 7000;
  }

  function cycleHero() {
    var slides = heroImgs();
    if (slides.length < 2 || !isNarrow()) {
      /* Clear the flag on the way out. watchHero raises `advancing` and then
         calls this; if it bails here — a resize to desktop mid-hand-over is
         enough — the flag was never lowered, because only showSlide lowers it.
         It would then stay raised for the rest of the session and every later
         `ended` would return early, leaving the hero frozen on one frame. */
      advancing = false;
      return;
    }
    slide = (slide + 1) % slides.length;
    showSlide();
  }

  /* ------------------------------------------- 4b. animated diagrams */
  /* Nothing animates off-screen. Tapping or clicking a tile runs it at double
     speed, which is the whole of the interaction — enough to reward a poke
     without turning a diagram into a toy. */
  function initAnim() {
    var els = $$('.mm-anim');
    if (!els.length) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { e.target.classList.toggle('is-in', e.isIntersecting); });
    }, { threshold: 0.25 });

    els.forEach(function (el) {
      io.observe(el);
      function boost() { el.classList.toggle('is-boost'); }
      on(el, 'click', boost);
      on(el, 'keydown', function (ev) {
        if (ev.key === 'Enter' || ev.key === ' ') { ev.preventDefault(); boost(); }
      });
      if (el.getAttribute('data-anim') === 'wash') washCount(el);
    });
  }

  // the number under the ripples: 1 → 100, then hold and start again
  function washCount(el) {
    var t = el.querySelector('.an-count');
    if (!t) return;
    if (reduceMotion) { t.textContent = '100'; return; }

    var n = 1, timer = null, hold = null;
    function tick() {
      n += 2;
      if (n >= 100) {
        n = 100;
        clearInterval(timer); timer = null;
        hold = setTimeout(function () { n = 1; t.textContent = '1'; run(); }, 1400);
      }
      t.textContent = n;
    }
    function run()  { if (!timer) timer = setInterval(tick, 70); }
    function stop() { clearInterval(timer); timer = null; clearTimeout(hold); }

    new IntersectionObserver(function (es) {
      es.forEach(function (e) { e.isIntersecting ? run() : stop(); });
    }, { threshold: 0.25 }).observe(el);
  }

  function initHeroVideo() {
    heroImgs().forEach(function (el, i) {
      if (el.tagName !== 'VIDEO') return;
      el.muted = true;                       // iOS will not autoplay otherwise
      el.playbackRate = heroRate();

      /* Last resort only, and it must check that this element is still the one
         on screen. The outgoing clip deliberately keeps playing through the
         fade, so its `ended` arrives ~0.2s AFTER the hand-over — and by then
         showSlide has already cleared `advancing`. Without the identity check
         that late event advances a second time, which lands back on this same
         element at frame 0: the hard cut the fade exists to avoid. */
      on(el, 'ended', function () {
        if (advancing || heroImgs()[slide] !== el) return;
        cycleHero();
      });
    });
    watchHero();
  }

  /* The hand-over is watched frame by frame rather than on `timeupdate`.
     timeupdate fires about four times a second, so a 0.2s overlap can fall
     between two ticks — the clip reaches its end untouched and cuts instead of
     dissolving. currentTime is media time, so the wall-clock tail is
     (duration - currentTime) / rate, hence the rate in the threshold. */
  var heroRaf = null;
  function watchHero() {
    if (reduceMotion || heroRaf) return;
    (function step() {
      heroRaf = requestAnimationFrame(step);
      if (advancing || !isNarrow()) return;
      var el = heroImgs()[slide];
      if (!el || el.tagName !== 'VIDEO' || !el.duration || el.paused) return;
      if (el.currentTime >= el.duration - HERO_FADE * heroRate()) {
        advancing = true;
        cycleHero();
      }
    })();
  }

  function heroIn() {
    var hero = $('.mm-hero');
    if (!hero) return;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { hero.classList.add('mm-lit'); });
    });
  }

  /* ----------------------------------------------------- 5. mobile menu */
  function initMenu() {
    var menu = $('.mm-menu');
    if (!menu) return;
    function open() {
      menu.classList.add('mm-open');
      document.body.style.overflow = 'hidden';
      menu.setAttribute('aria-hidden', 'false');
    }
    function close() {
      menu.classList.remove('mm-open');
      document.body.style.overflow = '';
      menu.setAttribute('aria-hidden', 'true');
    }
    $$('[data-menu-open]').forEach(function (b) { on(b, 'click', open); });
    $$('[data-menu-close]').forEach(function (b) { on(b, 'click', close); });
    on(document, 'keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ------------------------------------------------------- 6. cart core */
  function bagPop() {
    var b = $('.mm-bag__count');
    if (!b) return;
    b.classList.remove('mm-pop');
    void b.offsetWidth;
    b.classList.add('mm-pop');
  }

  function refreshBag(count) {
    $$('.mm-bag__count').forEach(function (el) { el.textContent = count; });
    $$('[data-bag-label]').forEach(function (el) {
      el.textContent = t('navBag', 'cart') + ' (' + count + ')';
    });
  }

  function getCart() {
    return fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart.js' : '/cart.js', {
      headers: { 'Accept': 'application/json' }
    }).then(function (r) { return r.json(); });
  }

  function addToCart(variantId, qty) {
    return addItems([{ id: variantId, quantity: qty || 1 }]);
  }

  /* One request for however many lines. The outfit builder sends two, and it
     has to be one call: two sequential adds can half-succeed and leave a
     trouser in the cart with no top. */
  function addItems(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || 'add failed'); });
      return r.json();
    });
  }

  function changeLine(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); });
  }

  function setAttribute(name, value) {
    var attrs = {};
    attrs[name] = value;
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).then(function (r) { return r.json(); });
  }

  /* ------------------------------------------------------- 7. cart drawer */
  function drawerEl() { return $('.mm-drawer'); }

  function openDrawer() {
    var d = drawerEl();
    if (!d) return;
    d.classList.add('mm-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    var d = drawerEl();
    if (!d) return;
    d.classList.remove('mm-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  /* What delivery really costs. The theme setting is printed server-side so
     the number is there at once; Shopify's own rate for this cart is asked
     for once per visit and wins if the two ever disagree, so the drawer
     cannot quote a total the checkout will not charge. One flat rate is all
     the shop has today; if zones are ever added the lowest is shown as
     "from". */
  var liveShip = null;          // { cents, from } once Shopify has answered
  var liveShipAsked = false;

  function askShipping(cart) {
    if (liveShipAsked || !cart.items.length) return;
    /* Above the free-delivery line Shopify answers 0, which says nothing
       about the price of delivery below it; only ask from a paid cart. */
    var foot0 = $('[data-drawer-foot]');
    var free0 = foot0 ? parseInt(foot0.getAttribute('data-free'), 10) || 0 : 0;
    if (free0 > 0 && cart.total_price >= free0) return;
    liveShipAsked = true;
    try {
      var kept = sessionStorage.getItem('mm-ship');
      if (kept) { liveShip = JSON.parse(kept); paintFoot(cart); return; }
    } catch (e) {}
    fetch('/cart/shipping_rates.json?shipping_address%5Bcountry%5D=Egypt&shipping_address%5Bprovince%5D=Cairo', {
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        var rates = j && j.shipping_rates;
        if (!rates || !rates.length) return;
        var cents = rates.map(function (x) { return Math.round(parseFloat(x.price) * 100); })
          .filter(function (c) { return c > 0; });
        if (!cents.length) return;
        var low = Math.min.apply(null, cents);
        liveShip = { cents: low, from: cents.some(function (c) { return c !== low; }) };
        try { sessionStorage.setItem('mm-ship', JSON.stringify(liveShip)); } catch (e) {}
        var foot = $('[data-drawer-foot]');
        var theme = foot ? parseInt(foot.getAttribute('data-ship'), 10) : NaN;
        if (theme !== low) {
          console.warn('[mammisi] Theme settings > Delivery says ' + theme / 100 +
            ', Shopify charges ' + low / 100 + '. Showing Shopify\'s.');
        }
        getCart().then(paintFoot);
      })
      .catch(function () {});
  }

  function paintFoot(cart) {
    var foot = $('[data-drawer-foot]');
    if (!foot) return;
    var free = parseInt(foot.getAttribute('data-free'), 10) || 0;
    var ship = liveShip ? liveShip.cents : (parseInt(foot.getAttribute('data-ship'), 10) || 0);
    var isFree = free > 0 && cart.total_price >= free;
    var shipText = isFree ? t('free', 'free')
      : (liveShip && liveShip.from ? t('fromPrice', 'from') + ' ' : '') + money(ship);

    foot.hidden = !cart.items.length;
    var el;
    if ((el = $('[data-drawer-subtotal]', foot))) el.textContent = money(cart.total_price);
    if ((el = $('[data-drawer-ship]', foot))) el.textContent = shipText;
    if ((el = $('[data-drawer-total]', foot))) el.textContent = money(cart.total_price + (isFree ? 0 : ship));

    /* Free-delivery bar: drawn only when Theme settings > Delivery has a
       threshold, which must only happen alongside a matching Shopify rule. */
    var bar = $('[data-drawer-free]');
    if (bar) {
      bar.hidden = !(free > 0 && cart.items.length);
      if (!bar.hidden) {
        var left = free - cart.total_price;
        $('[data-drawer-free-bar]', bar).style.width = Math.min(100, cart.total_price / free * 100) + '%';
        $('[data-drawer-free-note]', bar).textContent = left > 0
          ? t('freeAddA', 'add') + ' ' + money(left) + ' ' + t('freeAddB', 'for free delivery')
          : t('freeNote', 'free delivery across egypt');
        bar.classList.toggle('mm-freebar--done', left <= 0);
      }
    }
  }

  function renderDrawer(cart) {
    var body = $('.mm-drawer__body');
    if (!body) return;
    refreshBag(cart.item_count);
    paintFoot(cart);
    askShipping(cart);
    if (!cart.items.length) {
      body.innerHTML = '<div class="mm-drawer__empty">' + t('cartEmptyP', 'nothing folded in yet.') + '</div>';
      return;
    }
    body.innerHTML = cart.items.map(function (l) {
      var img = l.image ? l.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') : '';
      var variant = (l.options_with_values || [])
        .map(function (o) {
          return String(o.value)
            .replace(/ months?\b/, 'm')
            .replace(/ years?\b/, 'y');
        })
        .join(' · ');
      return '<div class="mm-drawer__line">' +
        '<div class="mm-drawer__img">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</div>' +
        '<div style="flex:1">' +
        '<div class="mm-drawer__t">' + l.product_title + '</div>' +
        '<div class="mm-drawer__v">' + variant + ' · ' + l.quantity + '</div>' +
        '</div>' +
        '<div style="font-size:13px">' + money(l.final_line_price) + '</div>' +
        '</div>';
    }).join('');
  }

  function initDrawer() {
    var d = drawerEl();
    if (!d) return;
    on(d, 'click', function (e) { if (e.target === d) closeDrawer(); });
    $$('[data-drawer-close]').forEach(function (b) { on(b, 'click', closeDrawer); });
    $$('[data-drawer-open]').forEach(function (b) {
      on(b, 'click', function (e) {
        e.preventDefault();
        getCart().then(function (c) { renderDrawer(c); openDrawer(); });
      });
    });
    on(document, 'keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
  }

  /* ------------------------------------------------ 8. product: sizes/add */
  function initProduct() {
    var form = $('[data-product-form]');
    if (!form) return;

    var variants = [];
    try { variants = JSON.parse($('[data-variants]').textContent); } catch (e) { variants = []; }

    var optionCount = parseInt(form.getAttribute('data-option-count') || '1', 10);
    var chosen = [];

    function currentVariant() {
      return variants.find(function (v) {
        for (var i = 0; i < optionCount; i++) {
          if (chosen[i] == null) return false;
          if (v.options[i] !== chosen[i]) return false;
        }
        return true;
      });
    }

    function stockNote(v) {
      if (!v) return '';
      if (!v.available) return t('soldOut', 'sold out');
      if (v.inventory_management && v.qty !== null && v.qty <= 4 && v.qty > 0) {
        return isAr() ? 'آخر ' + v.qty + ' قطع' : 'only ' + v.qty + ' left';
      }
      return t('inStock', 'in stock');
    }

    function shortSize(v) {
      return String(v).replace(/ months?\b/, 'm').replace(/ years?\b/, 'y');
    }

    function sync() {
      var v = currentVariant();
      var addBtns = $$('[data-add]');
      var priceEl = $('[data-price]');
      var idInput = $('[data-variant-id]');

      // echo each piece's chosen size beside its name
      $$('[data-chosen]').forEach(function (el) {
        var i = parseInt(el.getAttribute('data-chosen'), 10);
        el.textContent = chosen[i] ? shortSize(chosen[i]) : '';
        el.setAttribute('data-empty', t('pickSize', 'pick a size'));
      });

      // one stock note for the chosen combination, under the last piece
      var stocks = $$('[data-stock]');
      stocks.forEach(function (el, i) {
        el.textContent = i === stocks.length - 1 ? stockNote(v) : '';
      });

      if (v && priceEl) {
        priceEl.innerHTML = (v.compare_at_price && v.compare_at_price > v.price
          ? '<s>' + money(v.compare_at_price) + '</s>' : '') + money(v.price);
      }
      if (idInput && v) idInput.value = v.id;

      var sold = !v || !v.available;
      addBtns.forEach(function (b) {
        b.disabled = sold;
        b.textContent = sold ? t('soldOut', 'sold out') : t('addToCart', 'add to cart');
      });
      // buy now follows availability but keeps its own label
      $$('[data-buy]').forEach(function (b) { b.disabled = sold; });

      $$('[data-sticky-size]').forEach(function (el) {
        // match the compact labels used in the size grid
        var compact = chosen.filter(Boolean).map(function (v) {
          return String(v).replace(/ months?\b/, 'm').replace(/ years?\b/, 'y');
        });
        el.textContent = compact.join(' · ') || t('pickSize', 'pick a size');
      });
      $$('[data-sticky-price]').forEach(function (el) { if (v) el.textContent = money(v.price); });
    }

    // size buttons, one group per product option
    $$('[data-size]').forEach(function (btn) {
      var idx = parseInt(btn.getAttribute('data-opt-index') || '0', 10);
      on(btn, 'click', function () {
        if (btn.disabled) return;
        chosen[idx] = btn.getAttribute('data-size');
        $$('[data-size][data-opt-index="' + idx + '"]').forEach(function (b) {
          b.setAttribute('aria-pressed', String(b === btn));
        });
        sync();
        document.dispatchEvent(new CustomEvent('mammisi:sizechange'));
      });
    });

    // preselect the first available combination
    var firstAvail = variants.find(function (v) { return v.available; }) || variants[0];
    if (firstAvail) {
      firstAvail.options.slice(0, optionCount).forEach(function (val, i) {
        chosen[i] = val;
        // match by reading the attribute rather than building a selector —
        // option values contain spaces, which selector escaping mangles
        $$('[data-size][data-opt-index="' + i + '"]').forEach(function (b) {
          b.setAttribute('aria-pressed', String(b.getAttribute('data-size') === val));
        });
      });
    }
    sync();

    $$('[data-add]').forEach(function (btn) {
      on(btn, 'click', function (e) {
        e.preventDefault();
        var v = currentVariant();
        if (!v || !v.available) return;
        btn.disabled = true;
        addToCart(v.id, 1)
          .then(function () { return getCart(); })
          .then(function (c) { renderDrawer(c); bagPop(); openDrawer(); })
          .catch(function (err) { console.warn('[mammisi] add to cart:', err.message); })
          .finally(function () { btn.disabled = false; sync(); });
      });
    });

    /* Buy now: the same add, then straight to checkout. No drawer — opening it
       and then navigating away would only flash. */
    $$('[data-buy]').forEach(function (btn) {
      on(btn, 'click', function (e) {
        e.preventDefault();
        var v = currentVariant();
        if (!v || !v.available) return;
        btn.disabled = true;
        addToCart(v.id, 1)
          .then(function () {
            window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'checkout';
          })
          .catch(function (err) {
            console.warn('[mammisi] buy now:', err.message);
            btn.disabled = false;
          });
      });
    });
  }

  /* ------------------------------------------- 9. outfit builder / complete */
  /* The pair -> set map is built from metafield data rendered into the DOM.
     Nothing about the mapping is hardcoded here. */
  function initPairing(rootSel) {
    var root = $(rootSel);
    if (!root) return;

    var sets = [];
    var topsData = [];
    var botsData = [];
    try { sets = JSON.parse($('[data-sets]', root).textContent); } catch (e) { sets = []; }
    try { topsData = JSON.parse($('[data-tops]', root).textContent); } catch (e) { topsData = []; }
    try { botsData = JSON.parse($('[data-bottoms]', root).textContent); } catch (e) { botsData = []; }

    var state = {
      top: root.getAttribute('data-init-top'),
      bot: root.getAttribute('data-init-bottom'),
      topSize: null,
      botSize: null
    };

    /* The builder carries sizes and adds to the cart. The "completes the look"
       module on a product page shares this code but has no size row and keeps
       its link — one flag, decided by what is actually in the markup. */
    var boxT = $('[data-size-top]', root);
    var boxB = $('[data-size-bottom]', root);
    var buys = !!(boxT && boxB);
    var note = $('[data-pair-note]', root);
    var seeSet = $('[data-set-link]', root);

    function find(list, id) { return list.find(function (p) { return String(p.id) === String(id); }); }
    function setFor(topId, botId) {
      return sets.find(function (s) {
        return String(s.top) === String(topId) && String(s.bottom) === String(botId);
      });
    }

    function say(msg) { if (note) note.textContent = msg || ''; }
    function shortSize(s) {
      return String(s).replace(/\s*months?$/i, 'm').replace(/\s*years?$/i, 'y');
    }

    /* Which half of a set variant's "3-4 years / 5-6 years" belongs to which
       garment. Option ORDER is not reliable — the coastal blue set lists the
       top first, the pink pepper set lists the trouser first — so match on the
       option name, which Shopify builds as "<piece title> (Size)". */
    function optIndex(st, title) {
      var opts = st.options || [];
      for (var i = 0; i < opts.length; i++) {
        var nm = String(opts[i]).replace(/\s*\(\s*size\s*\)\s*$/i, '').trim().toLowerCase();
        if (nm === String(title).trim().toLowerCase()) return i;
      }
      return -1;
    }

    function setVariant(st, tp, bp) {
      if (!st || !st.variants) return null;
      var ti = optIndex(st, tp.title);
      var bi = optIndex(st, bp.title);
      if (ti < 0 || bi < 0) return null;
      return st.variants.find(function (v) {
        return v.opts[ti] === state.topSize && v.opts[bi] === state.botSize;
      }) || null;
    }

    function pieceVariant(p, size) {
      if (!p || !p.variants) return null;
      return p.variants.find(function (v) { return v.title === size; }) || null;
    }

    /* Sizes are drawn from the garment on the stage, so switching to a piece
       with a shorter ladder cannot leave a size selected that it never had.
       A size that exists in both ladders survives the switch. */
    function drawSizes(box, labelSel, p, which) {
      if (!box || !p) return;
      var sel = which === 'top' ? state.topSize : state.botSize;
      var list = p.variants || [];
      if (!list.some(function (v) { return v.title === sel; })) {
        var fallback = list.find(function (v) { return v.available; }) || list[0];
        sel = fallback ? fallback.title : null;
        if (which === 'top') state.topSize = sel; else state.botSize = sel;
      }
      var lab = $(labelSel, root);
      if (lab) lab.textContent = p.title;

      box.innerHTML = '';
      list.forEach(function (v) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'mm-size';
        b.textContent = shortSize(v.title);
        b.title = v.title;
        b.setAttribute('aria-pressed', String(v.title === sel));
        if (!v.available) b.disabled = true;
        b.addEventListener('click', function () {
          if (which === 'top') state.topSize = v.title; else state.botSize = v.title;
          say('');
          render();
        });
        box.appendChild(b);
      });
    }

    /* What this button would actually put in the cart. Where the pair is also
       sold as a made-up set, the set SKU wins: one line at the set's own
       Shopify price, which is the cheaper of the two routes. */
    function plan(tp, bp, st) {
      if (st) {
        var sv = setVariant(st, tp, bp);
        return { kind: 'set', variant: sv, items: sv && sv.available ? [{ id: sv.id, quantity: 1 }] : [] };
      }
      var tv = pieceVariant(tp, state.topSize);
      var bv = pieceVariant(bp, state.botSize);
      var ok = tv && bv && tv.available && bv.available;
      return {
        kind: 'pair',
        missing: !tv ? tp.title : (!bv ? bp.title : (!tv.available ? tp.title : (!bv.available ? bp.title : null))),
        items: ok ? [{ id: tv.id, quantity: 1 }, { id: bv.id, quantity: 1 }] : []
      };
    }

    function render() {
      var tp = find(topsData, state.top) || topsData[0];
      var bp = find(botsData, state.bot) || botsData[0];
      if (!tp || !bp) return;

      var stageT = $('[data-stage-top]', root);
      var stageB = $('[data-stage-bottom]', root);
      if (stageT) {
        var ti = $('img', stageT); if (ti) { ti.src = tp.img; ti.alt = tp.title; }
        var tl = $('.mm-stage__pill', stageT); if (tl) tl.textContent = tp.title;
      }
      if (stageB) {
        var bi = $('img', stageB); if (bi) { bi.src = bp.img; bi.alt = bp.title; }
        var bl = $('.mm-stage__pill', stageB); if (bl) bl.textContent = bp.title;
      }

      var sum = tp.price + bp.price;
      var st = setFor(tp.id, bp.id);

      if (buys) {
        drawSizes(boxT, '[data-size-label-top]', tp, 'top');
        drawSizes(boxB, '[data-size-label-bottom]', bp, 'bottom');
      }

      var sumEl = $('[data-sum]', root);
      var lSide = sumEl && sumEl.closest ? sumEl.closest('.mm-pricebar__side') : null;
      var rLabel = $('[data-set-label]', root);
      var rValue = $('[data-set-price]', root);
      var rSide = rLabel && rLabel.closest ? rLabel.closest('.mm-pricebar__side') : null;

      /* A set only reads as a saving if it actually is one. Set prices are
         now the sum of their pieces, so a set existing no longer implies money
         off — branching on that struck through a price identical to the one
         beside it and offered to "save LE 0.00". Everything below keys off the
         saving itself, so the bar stays honest whatever the pricing becomes. */
      var saving = st ? (sum - st.price) : 0;
      var hasSave = saving > 0;

      if (sumEl) {
        sumEl.textContent = money(sum);
        sumEl.classList.toggle('mm-struck', hasSave);
      }
      if (rLabel) rLabel.textContent = t('pairAsSet', 'as a set');
      if (rValue) rValue.textContent = st ? money(st.price) : '—';

      /* Only a real set product has a second price. A free pairing is simply
         its two prices added up, so the right-hand side is emptied rather than
         filled with a saving nobody has agreed to.

         `visibility`, not `hidden`: taking the element out of flow made the
         price bar shorter for a free pair and taller for a set, so the button
         jumped every time the pair changed. This way the tallest state holds
         the height for all of them, and visibility still keeps the empty slot
         out of the accessibility tree and off the tab order. */
      if (rSide) rSide.classList.toggle('mm-invis', !hasSave);
      if (lSide && buys) {
        var lLabel = $('.mm-pricebar__label', lSide);
        if (lLabel) {
          lLabel.textContent = hasSave
            ? t('pairSeparate', 'bought separately')
            : (isAr() ? 'القطعتان معًا' : 'the two together');
        }
      }

      var cta = $('[data-set-cta]', root);
      if (cta && buys) {
        var pl = plan(tp, bp, st);
        cta.disabled = !pl.items.length;
        if (st) {
          cta.textContent = pl.items.length
            ? (hasSave
                ? (isAr() ? 'أضيفي الطقم · وفّري ' : 'add the set · save ') + money(saving)
                : (isAr() ? 'أضيفي الطقم إلى السلة' : 'add the set to the cart'))
            : (isAr() ? 'هذا المقاس نفد' : 'that size is gone');
        } else {
          cta.textContent = pl.items.length
            ? (isAr() ? 'أضيفي القطعتين إلى السلة' : 'add both to the cart')
            : (isAr() ? 'هذا المقاس نفد' : 'that size is gone');
        }
        if (seeSet) {
          seeSet.classList.toggle('mm-invis', !st);
          if (st) {
            seeSet.textContent = (isAr() ? 'اقرئي عن ' : 'read about ') + st.title;
            seeSet.setAttribute('href', st.url);
          } else {
            seeSet.innerHTML = '&nbsp;';      // holds its line so nothing shifts
            seeSet.removeAttribute('href');
          }
        }
      } else if (cta) {
        if (st) {
          cta.textContent = hasSave
            ? (isAr() ? 'شاهدي الطقم · وفّري ' : 'see the set · save ') + money(saving)
            : (isAr() ? 'شاهدي الطقم' : 'see the set');
          cta.setAttribute('href', st.url);
        } else {
          var single = root.hasAttribute('data-complement-mode')
            ? (root.getAttribute('data-anchor') === 'top' ? bp : tp)
            : tp;
          cta.textContent = (isAr() ? 'شاهدي ' : 'shop the ') + single.title;
          cta.setAttribute('href', single.url);
        }
      }

      $$('[data-pick-top]', root).forEach(function (b) {
        b.setAttribute('aria-pressed', String(b.getAttribute('data-pick-top') === String(tp.id)));
      });
      $$('[data-pick-bottom]', root).forEach(function (b) {
        b.setAttribute('aria-pressed', String(b.getAttribute('data-pick-bottom') === String(bp.id)));
      });
    }

    $$('[data-pick-top]', root).forEach(function (b) {
      on(b, 'click', function () { state.top = b.getAttribute('data-pick-top'); say(''); render(); });
    });
    $$('[data-pick-bottom]', root).forEach(function (b) {
      on(b, 'click', function () { state.bot = b.getAttribute('data-pick-bottom'); say(''); render(); });
    });

    var addBtn = buys && $('[data-pair-add]', root);
    if (addBtn) {
      on(addBtn, 'click', function () {
        var tp = find(topsData, state.top) || topsData[0];
        var bp = find(botsData, state.bot) || botsData[0];
        if (!tp || !bp) return;
        var pl = plan(tp, bp, setFor(tp.id, bp.id));
        if (!pl.items.length) return;
        addBtn.disabled = true;
        say('');
        addItems(pl.items)
          .then(function () { return getCart(); })
          .then(function (c) { renderDrawer(c); bagPop(); openDrawer(); })
          .catch(function (err) {
            say(isAr() ? 'تعذّرت الإضافة إلى الحقيبة.' : 'could not add that to the cart.');
            console.warn('[mammisi] pair add:', err.message);
          })
          .finally(function () { render(); });
      });
    }

    render();
  }

  /* --------------------------------------------------- 8b. footer mark */
  /* Its own observer: the shared reveal utility sets opacity 0 and a
     translateY that would fight the mark's centring transform. */
  function initFooterMark() {
    var m = $('.mm-footer__mark');
    if (!m || m.hasAttribute('data-mark-seen')) return;
    m.setAttribute('data-mark-seen', '1');
    var mio = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('mm-in');
        mio.unobserve(e.target);
      });
    }, { threshold: 0.4 });
    mio.observe(m);
  }

  /* ------------------------------------------------- 9a. gallery carousel */
  function initGallery() {
    var root = $('[data-gallery]');
    if (!root) return;
    var track = $('[data-gallery-track]', root);
    var prev = $('[data-gallery-prev]', root);
    var next = $('[data-gallery-next]', root);
    if (!track) return;

    function step() {
      var slide = $('.mm-gallery__slide', track);
      return slide ? slide.getBoundingClientRect().width : track.clientWidth;
    }

    function syncArrows() {
      if (!prev || !next) return;
      // scrollLeft is negative in RTL on standards-compliant engines
      var x = Math.abs(track.scrollLeft);
      var max = track.scrollWidth - track.clientWidth - 1;
      prev.disabled = x <= 1;
      next.disabled = x >= max;
    }

    function go(dir) {
      var rtl = document.documentElement.getAttribute('dir') === 'rtl';
      track.scrollBy({ left: step() * dir * (rtl ? -1 : 1), behavior: 'smooth' });
    }

    on(prev, 'click', function () { go(-1); });
    on(next, 'click', function () { go(1); });
    on(track, 'scroll', syncArrows, { passive: true });

    // keyboard support when the track has focus
    on(track, 'keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
    });

    /* Thumbnails drive the same track, and follow it back when it is swiped,
       so the strip and the picture on screen never disagree. */
    var thumbs = $$('[data-gallery-thumbs] .mm-thumb', root);
    function syncThumbs() {
      if (!thumbs.length) return;
      var w = step() || 1;
      var at = Math.round(Math.abs(track.scrollLeft) / w);
      thumbs.forEach(function (t, i) { t.setAttribute('aria-selected', String(i === at)); });
    }
    thumbs.forEach(function (t, i) {
      on(t, 'click', function () {
        var rtl = document.documentElement.getAttribute('dir') === 'rtl';
        track.scrollTo({ left: step() * i * (rtl ? -1 : 1), behavior: 'smooth' });
      });
    });
    on(track, 'scroll', syncThumbs, { passive: true });

    on(document, 'mammisi:lang', syncArrows);
    syncArrows();
    syncThumbs();
  }

  /* ---------------------------------------------------- 9b. size guide */
  function initSizeGuide() {
    var g = $('[data-guide]');
    if (!g) return;
    var active = 0;

    function sizeButtons(i) {
      return $$('[data-size][data-opt-index="' + i + '"]');
    }

    function syncGuide() {
      var btns = sizeButtons(active);
      $$('[data-guide-size]', g).forEach(function (row) {
        var val = row.getAttribute('data-guide-size');
        var hit = btns.filter(function (b) { return b.getAttribute('data-size') === val; })[0];
        var available = hit && !hit.disabled;
        row.disabled = !available;
        row.classList.toggle('mm-out', !available);
        row.setAttribute('aria-pressed',
          hit && hit.getAttribute('aria-pressed') === 'true' ? 'true' : 'false');
      });
    }

    function open() {
      syncGuide();
      g.classList.add('mm-open');
      g.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var c = $('[data-guide-close]', g);
      if (c) c.focus();
    }
    function close() {
      g.classList.remove('mm-open');
      g.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    $$('[data-guide-open]').forEach(function (b) {
      on(b, 'click', function () {
        // the arrow was only ever there to get this click
        $$('[data-guide-nudge]').forEach(function (n) { n.classList.add('mm-done'); });
        open();
      });
    });
    $$('[data-guide-close]', g).forEach(function (b) { on(b, 'click', close); });
    on(g, 'click', function (e) { if (e.target === g) close(); });
    on(document, 'keydown', function (e) {
      if (e.key === 'Escape' && g.classList.contains('mm-open')) close();
    });

    $$('[data-guide-piece]', g).forEach(function (b) {
      on(b, 'click', function () {
        active = parseInt(b.getAttribute('data-guide-piece'), 10) || 0;
        $$('[data-guide-piece]', g).forEach(function (x) {
          x.setAttribute('aria-pressed', String(x === b));
        });
        syncGuide();
      });
    });

    /* Tapping a row used to apply the size and shut the guide in the same
       motion, which meant the panel vanished the instant you touched the table
       you were still reading. A row now only moves the highlight and redraws
       the blueprint; the button underneath is what commits and closes. */
    function applyChosen() {
      var row = $('[data-guide-size].mm-cur', g) || $('[data-guide-size]', g);
      if (!row) return;
      var val = row.getAttribute('data-guide-size');
      var hit = sizeButtons(active).filter(function (b) {
        return b.getAttribute('data-size') === val;
      })[0];
      if (!hit || hit.disabled) return;
      hit.click();
      syncGuide();
      close();
    }
    $$('[data-guide-apply]', g).forEach(function (b) { on(b, 'click', applyChosen); });

    document.addEventListener('mammisi:sizechange', syncGuide);

    /* ---------------------------------------------- the blueprint + slider */
    /* The European scale is a height in centimetres, so it doubles as the
       child reading. Garment numbers come from the metafield; anything not
       measured stays an em dash rather than being interpolated. */
    var EU = {
      '12-18m': [86, '80–86'], '18-24m': [92, '86–92'], '1-2y': [92, '86–92'],
      '2y': [92, '86–92'], '2-3y': [98, '92–98'], '3y': [98, '92–98'],
      '3-4y': [104, '98–104'], '4y': [104, '98–104'], '4-5y': [110, '104–110'],
      '5y': [110, '104–110'], '5-6y': [116, '110–116'], '6y': [116, '110–116'],
      '6-7y': [122, '116–122'], '7-8y': [128, '122–128']
    };
    function key(label) {
      return String(label).toLowerCase()
        .replace(/\s*months?/, 'm').replace(/\s*years?/, 'y')
        .replace(/\s+/g, '').replace(/–/g, '-');
    }

    var raw = $('[data-guide-chart]', g);
    var data = null;
    try { data = raw ? JSON.parse(raw.textContent) : null; } catch (e) { data = null; }

    var rows   = $$('[data-guide-size]', g);
    var range  = $('[data-guide-range]', g);
    var scale  = $('[data-guide-scale]', g);
    var shape  = $('[data-bp-shape]', g);
    var dimLen = $('[data-bp-dimlen]', g);
    var dimWid = $('[data-bp-dimwid]', g);
    var lenVal = $('[data-bp-lenval]', g);
    var widVal = $('[data-bp-widval]', g);
    var detail = $('[data-bp-detail]', g);
    var empty  = $('[data-bp-empty]', g);
    if (!range || !shape || !rows.length) return;

    var sizesByPiece = null;
    try { sizesByPiece = JSON.parse($('[data-guide-sizes]', g).textContent); } catch (e) {}

    /* Which sizes the piece currently on screen is actually sold in. */
    function soldSizes() {
      if (!sizesByPiece) return null;
      var keys = Object.keys(sizesByPiece);
      if (!keys.length) return null;
      var btn = $$('[data-guide-piece]', g)[active];
      var nm = btn && btn.getAttribute('data-piece-name');
      return sizesByPiece[nm] || sizesByPiece[keys[0]] || null;
    }

    function liveRows() {
      var only = soldSizes();
      if (!only || !only.length) return rows;
      var has = {};
      only.forEach(function (s) { has[key(s)] = 1; });
      var out = rows.filter(function (r) { return has[key(r.getAttribute('data-guide-size'))]; });
      return out.length ? out : rows;
    }

    /* Rebuild the ladder for the piece on screen: drop the sizes it is not made
       in, re-label the scale, and re-scope the slider. Without this a garment
       that stops at 2-3 years still offered 12-18 months, and that empty row
       was indistinguishable from a size that exists but has no measurement. */
    function syncLadder() {
      var live = liveRows();
      rows.forEach(function (r) { r.hidden = live.indexOf(r) === -1; });
      range.max = String(Math.max(0, live.length - 1));
      if (scale) {
        scale.innerHTML = '';
        live.forEach(function (r) {
          var d = document.createElement('span');
          d.textContent = r.getAttribute('data-guide-size')
            .replace(/\s*months?/, 'm').replace(/\s*years?/, 'y');
          scale.appendChild(d);
        });
      }
      return live;
    }

    function chartFor() {
      if (!data) return null;
      if (!data.pieces) return data;
      var btn = $$('[data-guide-piece]', g)[active];
      var nm = btn && btn.getAttribute('data-piece-name');
      return (nm && data.pieces[nm]) || data.pieces[Object.keys(data.pieces)[0]] || null;
    }

    function rowFor(ch, label) {
      if (!ch || !ch.rows) return null;
      var k = key(label);
      for (var i = 0; i < ch.rows.length; i++) {
        if (key(ch.rows[i].size) === k) return ch.rows[i];
      }
      return null;
    }

    // ---- geometry -------------------------------------------------------
    function tee(w, l, cx, y0) {
      var s = w * 0.30, sl = l * 0.24, hw = w / 2;
      return 'M' + (cx - hw) + ' ' + y0 +
        'L' + (cx - hw - s) + ' ' + (y0 + sl * 0.55) +
        'L' + (cx - hw - s * 0.72) + ' ' + (y0 + sl) +
        'L' + (cx - hw) + ' ' + (y0 + sl * 0.72) +
        'L' + (cx - hw) + ' ' + (y0 + l) +
        'L' + (cx + hw) + ' ' + (y0 + l) +
        'L' + (cx + hw) + ' ' + (y0 + sl * 0.72) +
        'L' + (cx + hw + s * 0.72) + ' ' + (y0 + sl) +
        'L' + (cx + hw + s) + ' ' + (y0 + sl * 0.55) +
        'L' + (cx + hw) + ' ' + y0 +
        'Q' + cx + ' ' + (y0 + w * 0.16) + ' ' + (cx - hw) + ' ' + y0 + 'Z';
    }
    function trouser(w, l, cx, y0) {
      var hw = w / 2, flare = w * 0.34;
      return 'M' + (cx - hw) + ' ' + y0 +
        'L' + (cx + hw) + ' ' + y0 +
        'L' + (cx + hw + flare) + ' ' + (y0 + l) +
        'L' + (cx + flare * 0.35) + ' ' + (y0 + l) +
        'L' + cx + ' ' + (y0 + l * 0.52) +
        'L' + (cx - flare * 0.35) + ' ' + (y0 + l) +
        'L' + (cx - hw - flare) + ' ' + (y0 + l) + 'Z';
    }

    /* Stretch a traced outline to the measured box. The outline carries the
       garment's real shape; width and length carry its real size, so the two
       axes scale independently — which is correct, since length grows faster
       than width across the run. */
    /* Scale a unit-box path onto the measured box. x 0..1 is the body width,
       y 0..1 the length, so sleeves running outside 0..1 land outside the
       dimension lines — which is right, since the measurement is the chest,
       not the sleeve span. Handles M, L and C; Z passes through. */
    function fromOutline(d, W, L, cx, y0) {
      var x0 = cx - W / 2;
      return d.replace(/([MLC])([^MLCZ]*)/gi, function (_, cmd, nums) {
        var n = nums.trim().split(/[\s,]+/).filter(function (v) { return v !== ''; });
        var o = [];
        for (var i = 0; i + 1 < n.length; i += 2) {
          o.push((x0 + parseFloat(n[i]) * W).toFixed(2),
                 (y0 + parseFloat(n[i + 1]) * L).toFixed(2));
        }
        return cmd + o.join(' ');
      });
    }

    function shapeFor(kind) {
      var shapes = window.MammisiShapes, map = window.MammisiGarments || {};
      if (!shapes) return null;
      var name = null;
      if (data && data.pieces) {
        var btn = $$('[data-guide-piece]', g)[active];
        name = btn && btn.getAttribute('data-piece-name');
      }
      if (!name) name = g.getAttribute('data-title');
      var key = map[name] || (kind === 'bottom' ? 'trouser' : 'tee');
      return shapes[key] || null;
    }

    var cur = null, tween = null;
    function draw(w, l, kind) {
      var maxL = 126, maxW = 86;
      // one scale across the whole run, so bigger sizes are visibly bigger
      var ch = chartFor(), pxL = 2.2, pxW = 2.2;
      if (ch && ch.rows && ch.rows.length) {
        var mL = 0, mW = 0;
        ch.rows.forEach(function (r) { mL = Math.max(mL, r.length); mW = Math.max(mW, r.width); });
        pxL = maxL / mL; pxW = maxW / mW;
      }
      var W = w * pxW, L = l * pxL;
      var cx = 100, y0 = 20 + (maxL - L) * 0.5;
      var sh = shapeFor(kind);
      shape.setAttribute('d', sh
        ? fromOutline(sh.body, W, L, cx, y0)
        : (kind === 'bottom' ? trouser(W, L, cx, y0) : tee(W, L, cx, y0)));
      if (detail) {
        detail.setAttribute('d', sh && sh.detail ? fromOutline(sh.detail, W, L, cx, y0) : '');
      }

      var lx = cx - W / 2 - (kind === 'bottom' ? W * 0.34 : W * 0.30) - 14;
      dimLen.setAttribute('d', 'M' + lx + ' ' + y0 + 'V' + (y0 + L) +
        'M' + (lx - 4) + ' ' + y0 + 'H' + (lx + 4) +
        'M' + (lx - 4) + ' ' + (y0 + L) + 'H' + (lx + 4));
      lenVal.setAttribute('x', lx - 9); lenVal.setAttribute('y', y0 + L / 2 + 4);
      lenVal.setAttribute('transform', 'rotate(-90 ' + (lx - 9) + ' ' + (y0 + L / 2 + 4) + ')');

      var wy = y0 + L + 14;
      dimWid.setAttribute('d', 'M' + (cx - W / 2) + ' ' + wy + 'H' + (cx + W / 2) +
        'M' + (cx - W / 2) + ' ' + (wy - 4) + 'V' + (wy + 4) +
        'M' + (cx + W / 2) + ' ' + (wy - 4) + 'V' + (wy + 4));
      widVal.setAttribute('x', cx); widVal.setAttribute('y', wy + 15);
    }

    /* Draw straight to the target. An earlier version eased between sizes over
       a few frames; dragging the slider fires often enough that the tween was
       being cancelled and restarted faster than it could paint, so the shape
       sat on whichever size it happened to reach first. Six discrete steps
       redraw cleanly on their own. */
    function tweenTo(w, l, kind) {
      cur = { w: w, l: l };
      draw(w, l, kind);
    }

    /* Name the columns after what was measured. The headings had been typed
       as "height cm" and "chest cm", so a parent read "3-4y · height 40 cm"
       and a trouser's waist under "chest". The chart knows its own measures. */
    var WID_AR = { 'chest, flat': 'colChest', 'waist, flat': 'colWaist' };
    function paintHeads() {
      var ch = chartFor();
      var m = ch && ch.measures;
      var heads = [['colLen', m && m[0]], ['colWid', m && m[1]]];
      heads.forEach(function (h) {
        var el = $('.mm-guide__row--head [data-i18n="' + h[0] + '"]', g);
        if (!el || !h[1]) return;
        var en = h[1].label;
        var arKey = h[0] === 'colLen' ? 'colLen' : WID_AR[en];
        el.setAttribute('data-en', en);
        el.textContent = isAr() && arKey && T[arKey] ? T[arKey] : en;
      });
    }
    document.addEventListener('mammisi:lang', paintHeads);

    function paintTable() {
      var ch = chartFor();
      paintHeads();
      rows.forEach(function (row) {
        var r = rowFor(ch, row.getAttribute('data-guide-size'));
        var k = key(row.getAttribute('data-guide-size'));
        var eu = EU[k];
        var c = row.querySelector('[data-cell-eu]');
        var cl = row.querySelector('[data-cell-len]');
        var cw = row.querySelector('[data-cell-wid]');
        if (c)  c.textContent  = eu ? eu[0] : '—';
        if (cl) cl.textContent = r ? r.length + ' cm' : '—';
        if (cw) cw.textContent = r ? r.width + ' cm' : '—';
      });
    }

    function select(i, fromRange) {
      var live = liveRows();
      i = Math.max(0, Math.min(live.length - 1, i));
      if (!fromRange) range.value = String(i);
      rows.forEach(function (r) { r.classList.toggle('mm-cur', r === live[i]); });
      if (scale) {
        Array.prototype.forEach.call(scale.children, function (d, n) {
          d.classList.toggle('mm-on', n === i);
        });
      }
      var label = live[i].getAttribute('data-guide-size');
      var k = key(label), eu = EU[k], ch = chartFor(), r = rowFor(ch, label);

      var ageEl = $('[data-ro-age]', g), euEl = $('[data-ro-eu]', g), hEl = $('[data-ro-height]', g);
      var shortLab = label.replace(/\s*months?/, 'm').replace(/\s*years?/, 'y');
      if (ageEl) ageEl.textContent = shortLab;
      if (euEl)  euEl.textContent  = eu ? eu[0] : '—';
      if (hEl)   hEl.textContent   = eu ? eu[1] + ' cm' : '—';

      /* The button names the size it will pick, and goes quiet when that size
         is not one the piece can actually be bought in. */
      var applyBtn = $('[data-guide-apply]', g);
      if (applyBtn) {
        var buyable = sizeButtons(active).filter(function (b) {
          return b.getAttribute('data-size') === label && !b.disabled;
        })[0];
        applyBtn.disabled = !buyable;
        var lab = $('[data-guide-apply-label]', applyBtn);
        if (lab) {
          lab.textContent = buyable
            ? t('guideApply', 'select this size') + ' · ' + shortLab
            : t('soldOut', 'sold out');
        }
      }

      if (r) {
        if (empty) empty.hidden = true;
        shape.style.opacity = ''; dimLen.style.opacity = ''; dimWid.style.opacity = '';
        if (detail) detail.style.opacity = '';
        lenVal.textContent = r.length + ' cm';
        widVal.textContent = r.width + ' cm';
        tweenTo(r.width, r.length, ch && ch.kind);
      } else {
        // measured rows only — nothing here is interpolated
        if (empty) empty.hidden = false;
        shape.style.opacity = '.12'; dimLen.style.opacity = '0'; dimWid.style.opacity = '0';
        if (detail) detail.style.opacity = '0';
        lenVal.textContent = ''; widVal.textContent = '';
      }
    }

    on(range, 'input', function () { select(parseInt(range.value, 10) || 0, true); });
    rows.forEach(function (row) {
      on(row, 'click', function () {
        var at = liveRows().indexOf(row);
        if (at > -1) select(at);
      });
    });
    $$('[data-guide-piece]', g).forEach(function (b) {
      on(b, 'click', function () {
        cur = null;
        syncLadder();                       // the other piece may sell other sizes
        paintTable();
        select(parseInt(range.value, 10) || 0);
      });
    });

    syncLadder();
    paintTable();
    select(0);
  }

  /* ------------------------------------------------ 9c. the sizing page */
  /* Three drawings that carry the explanations on /pages/sizing-and-fit. They
     reuse MammisiShapes, so the tee drawn here is the tee the product-page
     blueprint draws — one set of outlines, not a second set that drifts. */
  function initSizing() {
    var root = $('.mm-szpage');
    if (!root) return;

    function scale(d, W, L, cx, y0) {
      var x0 = cx - W / 2;
      return d.replace(/([MLC])([^MLCZ]*)/gi, function (_, cmd, nums) {
        var n = nums.trim().split(/[\s,]+/).filter(function (v) { return v !== ''; });
        var o = [];
        for (var i = 0; i + 1 < n.length; i += 2) {
          o.push((x0 + parseFloat(n[i]) * W).toFixed(2),
                 (y0 + parseFloat(n[i + 1]) * L).toFixed(2));
        }
        return cmd + o.join(' ');
      });
    }

    var shapes = window.MammisiShapes;
    if (!shapes || !shapes.tee) return;

    /* --- the flat-measure diagram --- */
    var flat = $('[data-flat]', root);
    if (flat) {
      var W = 96, L = 104, cx = 100, y0 = 44;
      var set = function (sel, d) { var e = $(sel, flat); if (e) e.setAttribute('d', d); };
      set('[data-flat-shape]', scale(shapes.tee.body, W, L, cx, y0));
      if (shapes.tee.detail) set('[data-flat-detail]', scale(shapes.tee.detail, W, L, cx, y0));

      var left = cx - W / 2, right = cx + W / 2, bottom = y0 + L;
      // length runs down the left edge, chest across the bottom — the two
      // numbers every product page publishes, drawn where they are taken
      set('[data-flat-len]', 'M' + (left - 16) + ' ' + y0 + 'V' + bottom +
                             'M' + (left - 21) + ' ' + y0 + 'h10' +
                             'M' + (left - 21) + ' ' + bottom + 'h10');
      set('[data-flat-wid]', 'M' + left + ' ' + (bottom + 16) + 'H' + right +
                             'M' + left + ' ' + (bottom + 11) + 'v10' +
                             'M' + right + ' ' + (bottom + 11) + 'v10');
      var ll = $('[data-flat-lenlab]', flat), wl = $('[data-flat-widlab]', flat);
      if (ll) { ll.setAttribute('x', left - 30); ll.setAttribute('y', y0 + L / 2);
                ll.setAttribute('transform', 'rotate(-90 ' + (left - 30) + ' ' + (y0 + L / 2) + ')'); }
      if (wl) { wl.setAttribute('x', cx); wl.setAttribute('y', bottom + 34); }
    }

    /* --- growing room: the same outline at two sizes, one over the other --- */
    var room = $('[data-room]', root);
    if (room) {
      var s = $('[data-room-small]', room), b = $('[data-room-big]', room);
      // 3-4y against 5-6y, from the measured honey dune rows: 27x40 and 31x47
      if (s) s.setAttribute('d', scale(shapes.tee.body, 74, 88, 100, 74));
      if (b) b.setAttribute('d', scale(shapes.tee.body, 86, 104, 100, 58));
    }

    /* Nothing animates until it is looked at. */
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { e.target.classList.toggle('is-in', e.isIntersecting); });
    }, { threshold: 0.3 });
    $$('[data-ruler], [data-flat], [data-room]', root).forEach(function (el) { io.observe(el); });
  }

  /* --------------------------------------------------------- 10. anatomy */
  function initAnatomy() {
    var root = $('.mm-anatomy');
    if (!root) return;
    var data = [];
    try { data = JSON.parse($('[data-anatomy]', root).textContent); } catch (e) { return; }
    if (!data.length) return;

    var titleEl = $('.mm-anatomy__t', root);
    var bodyEl = $('.mm-anatomy__b', root);
    var idxEl = $('.mm-anatomy__idx', root);

    function show(i) {
      var h = data[i];
      if (!h) return;
      if (titleEl) titleEl.textContent = isAr() && h.title_ar ? h.title_ar : h.title;
      if (bodyEl) bodyEl.textContent = isAr() && h.body_ar ? h.body_ar : h.body;
      if (idxEl) idxEl.textContent = (i + 1) + ' / ' + data.length;
      $$('.mm-dot', root).forEach(function (d, j) { d.setAttribute('aria-pressed', String(j === i)); });
      $$('.mm-bars button', root).forEach(function (b, j) { b.setAttribute('aria-pressed', String(j === i)); });
    }

    $$('.mm-dot', root).forEach(function (d, i) { on(d, 'click', function () { show(i); }); });
    $$('.mm-bars button', root).forEach(function (b, i) { on(b, 'click', function () { show(i); }); });
    show(0);
  }

  /* ----------------------------------------------------- 11. gift finder */
  function initGift() {
    var root = $('.mm-gift');
    if (!root) return;
    var picks = [];
    try { picks = JSON.parse($('[data-gift]', root).textContent); } catch (e) { return; }

    function show(key) {
      var p = picks.find(function (x) { return x.key === key; });
      if (!p) return;
      var img = $('.mm-gift__img img', root);
      if (img) { img.src = p.img; img.alt = p.title; }
      var tag = $('.mm-gift__tag', root);
      if (tag) tag.textContent = (isAr() ? 'اخترناه لـ' : 'chosen for a ') + p.label;
      var ti = $('.mm-gift__t', root); if (ti) ti.textContent = p.title;
      var nt = $('.mm-gift__note', root);
      if (nt) nt.textContent = (isAr() && p.note_ar) ? p.note_ar : p.note;
      var pr = $('.mm-gift__price', root); if (pr) pr.textContent = money(p.price);
      var cta = $('.mm-gift__cta', root); if (cta) cta.setAttribute('href', p.url);
      $$('.mm-pill', root).forEach(function (b) {
        b.setAttribute('aria-pressed', String(b.getAttribute('data-occasion') === key));
      });
    }
    $$('.mm-pill', root).forEach(function (b) {
      on(b, 'click', function () { show(b.getAttribute('data-occasion')); });
    });
    if (picks.length) show(picks[0].key);
  }

  /* ------------------------------------------------------- 12. cart page */
  function initCartPage() {
    var page = $('.mm-cart');
    if (!page) return;

    $$('[data-qty]').forEach(function (btn) {
      on(btn, 'click', function () {
        var key = btn.getAttribute('data-key');
        var next = parseInt(btn.getAttribute('data-qty'), 10);
        btn.disabled = true;
        changeLine(key, next).then(function () { window.location.reload(); });
      });
    });

    $$('[data-remove]').forEach(function (btn) {
      on(btn, 'click', function () {
        var key = btn.getAttribute('data-remove');
        btn.disabled = true;
        changeLine(key, 0).then(function () { window.location.reload(); });
      });
    });

    /* The sticky checkout bar steps aside while the summary's own button is
       on screen. Without IntersectionObserver it simply stays. */
    var bar = $('[data-cartbar]');
    var real = $('.mm-checkout', page);
    if (bar && real && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        bar.classList.toggle('mm-cartbar--off', es[0].isIntersecting);
      }).observe(real);
    }
  }

  /* ------------------------------------------- 13. fabric tap-to-zoom */
  function initFabric() {
    var m = $('.mm-fabric__media');
    if (!m) return;
    var touch = window.matchMedia('(hover: none)').matches;
    if (!touch) return;
    on(m, 'click', function () { m.classList.toggle('mm-zoom'); });
  }

  /* ------------------------------------------------- 14. language toggle */
  function initLang() {
    $$('[data-lang-toggle]').forEach(function (btn) {
      on(btn, 'click', function (e) {
        // If Arabic is a published Shopify locale, use the real localized URL.
        if (CFG.arPublished && CFG.arUrl) { window.location.href = CFG.arUrl; return; }
        // Otherwise mirror the design reference: flip dir + swap strings client-side.
        e.preventDefault();
        var toAr = !isAr();
        applyLang(toAr ? 'ar' : 'en');
        try { localStorage.setItem('mammisi-lang', toAr ? 'ar' : 'en'); } catch (err) {}
      });
    });
    var saved = null;
    try { saved = localStorage.getItem('mammisi-lang'); } catch (e) {}
    if (saved === 'ar') applyLang('ar');
  }

  function applyLang(lang) {
    var ar = lang === 'ar';
    document.documentElement.setAttribute('dir', ar ? 'rtl' : 'ltr');
    document.documentElement.setAttribute('lang', ar ? 'ar' : 'en');

    $$('[data-i18n]').forEach(function (el) {
      var k = el.getAttribute('data-i18n');
      if (!el.hasAttribute('data-en')) el.setAttribute('data-en', el.textContent);
      var v = ar ? T[k] : el.getAttribute('data-en');
      // a live number (the delivery price) rides in on the element itself
      if (ar && v && el.hasAttribute('data-rate-ar')) v = v.replace('{rate}', el.getAttribute('data-rate-ar'));
      if (v && el.textContent !== v) el.textContent = v;
    });
    $$('[data-i18n-ph]').forEach(function (el) {
      var k = el.getAttribute('data-i18n-ph');
      if (!el.hasAttribute('data-en-ph')) el.setAttribute('data-en-ph', el.placeholder || '');
      el.placeholder = ar ? (T[k] || el.getAttribute('data-en-ph')) : el.getAttribute('data-en-ph');
    });
    $$('[data-lang-toggle]').forEach(function (b) { b.textContent = ar ? 'EN' : 'ع'; });

    // re-render dynamic modules so their strings follow the language
    initAnatomy();
    document.dispatchEvent(new CustomEvent('mammisi:lang', { detail: { lang: lang } }));
  }

  /* ------------------------------------------------------- 15. newsletter */
  function initNews() {
    var f = $('.mm-news-form');
    if (!f) return;
    on(f, 'submit', function () { /* posts to Shopify's customer form endpoint */ });
  }

  /* ------------------------------------------------------ 16. the films */
  /* Muted loops that only run while they are on screen, and one sound button:
     turning a film's sound on mutes every other film, so a page never has two
     voices in it. Under reduced motion nothing autoplays — the films get their
     native controls and wait to be asked. */
  var filmObserver = null;

  function initFilms() {
    var films = $$('[data-film]');
    if (!films.length) return;
    var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (still) {
      films.forEach(function (v) { v.controls = true; });
    } else {
      if (filmObserver) filmObserver.disconnect();
      filmObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting && e.intersectionRatio > 0.45) {
            var playing = v.play();
            if (playing && playing.catch) playing.catch(function () {});
          } else {
            v.pause();
            if (!v.muted) quiet(v);
          }
        });
      }, { threshold: [0, 0.45, 0.8] });
      films.forEach(function (v) { filmObserver.observe(v); });
    }

    $$('[data-film-toggle]').forEach(function (btn) {
      if (btn.dataset.wired) return;
      btn.dataset.wired = '1';
      on(btn, 'click', function (e) {
        e.preventDefault();
        var v = $('[data-film]', btn.closest('.mm-film__frame'));
        if (!v) return;
        if (v.muted) {
          films.forEach(function (o) { if (o !== v) quiet(o); });
          v.muted = false;
          btn.setAttribute('aria-pressed', 'true');
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else {
          quiet(v);
        }
      });
    });
  }

  /* mute a film and put its button back */
  function quiet(video) {
    video.muted = true;
    var frame = video.closest('.mm-film__frame');
    var btn = frame && $('[data-film-toggle]', frame);
    if (btn) btn.setAttribute('aria-pressed', 'false');
  }

  /* ------------------------------------------------- 17. the lightbox */
  /* The photographs at the size they were shot. Built once, on the first
     click, so a product page costs nothing until someone asks. */
  var lb = null;

  function buildLightbox() {
    if (lb) return lb;
    var el = document.createElement('div');
    el.className = 'mm-lightbox';
    el.hidden = true;
    el.innerHTML =
      '<img alt="">' +
      '<button class="mm-lightbox__btn mm-lightbox__close" type="button" aria-label="close">' +
        '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19" fill="none" stroke="currentColor" stroke-width="1.25" stroke-linecap="round"/></svg>' +
      '</button>' +
      '<button class="mm-lightbox__btn mm-lightbox__prev" type="button" aria-label="previous photograph">' +
        '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 4L7 12l8 8" fill="none" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      '</button>' +
      '<button class="mm-lightbox__btn mm-lightbox__next" type="button" aria-label="next photograph">' +
        '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 4l8 8-8 8" fill="none" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      '</button>' +
      '<span class="mm-lightbox__count"></span>';
    document.body.appendChild(el);
    lb = {
      el: el,
      img: $('img', el),
      count: $('.mm-lightbox__count', el),
      items: [],
      i: 0,
      opener: null
    };
    on($('.mm-lightbox__close', el), 'click', closeLightbox);
    on($('.mm-lightbox__prev', el), 'click', function () { step(-1); });
    on($('.mm-lightbox__next', el), 'click', function () { step(1); });
    on(el, 'click', function (e) { if (e.target === el || e.target === lb.img) closeLightbox(); });
    on(document, 'keydown', function (e) {
      if (!lb || lb.el.hidden) return;
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowRight') step(1);
      if (e.key === 'ArrowLeft') step(-1);
    });
    return lb;
  }

  function show(i) {
    var n = lb.items.length;
    lb.i = (i + n) % n;
    var btn = lb.items[lb.i];
    lb.img.src = btn.getAttribute('data-lightbox');
    lb.img.alt = btn.getAttribute('aria-label') || '';
    lb.count.textContent = (lb.i + 1) + ' / ' + n;
    var many = n > 1;
    $('.mm-lightbox__prev', lb.el).hidden = !many;
    $('.mm-lightbox__next', lb.el).hidden = !many;
    lb.count.hidden = !many;
  }

  function step(d) { if (lb && lb.items.length) show(lb.i + d); }

  function closeLightbox() {
    if (!lb || lb.el.hidden) return;
    lb.el.classList.remove('is-open');
    document.body.classList.remove('mm-lightbox-open');
    window.setTimeout(function () { lb.el.hidden = true; lb.img.removeAttribute('src'); }, 280);
    if (lb.opener) lb.opener.focus();
  }

  function initLightbox() {
    var groups = $$('[data-lightbox-group]');
    if (!groups.length) return;
    groups.forEach(function (g) {
      if (g.dataset.wired) return;
      g.dataset.wired = '1';
      on(g, 'click', function (e) {
        var btn = e.target.closest('[data-lightbox]');
        if (!btn) return;
        e.preventDefault();
        buildLightbox();
        lb.items = $$('[data-lightbox]', g);
        lb.opener = btn;
        lb.el.hidden = false;
        document.body.classList.add('mm-lightbox-open');
        show(lb.items.indexOf(btn));
        window.requestAnimationFrame(function () { lb.el.classList.add('is-open'); });
        $('.mm-lightbox__close', lb.el).focus();
      });
    });
  }

  /* ---------------------------------------------------------------- boot */
  function boot() {
    document.body.classList.add('mm');
    syncNarrow();
    collectParallax();
    initReveal();
    initTimeline();
    heroIn();
    initHeroVideo();
    initHeroWide();
    nudgePlay();
    initAnim();
    initMenu();
    initFooterMark();
    initDrawer();
    initProduct();
    initGallery();
    initSizeGuide();
    initPairing('[data-pair="builder"]');
    initPairing('[data-pair="complete"]');
    initAnatomy();
    initGift();
    initCartPage();
    initFabric();
    initSizing();
    initLang();
    initNews();
    initFilms();
    initLightbox();
    parallax();

    on(window, 'scroll', parallax, { passive: true });

    // re-render pairing modules when the language flips
    on(document, 'mammisi:lang', function () {
      initPairing('[data-pair="builder"]');
      initPairing('[data-pair="complete"]');
      initGift();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Shopify theme editor support
  document.addEventListener('shopify:section:load', function () {
    collectParallax(); initReveal(); initTimeline(); initFooterMark(); initProduct(); initGallery(); initSizeGuide();
    initPairing('[data-pair="builder"]'); initPairing('[data-pair="complete"]');
    initAnatomy(); initGift(); initCartPage(); initFabric(); initSizing(); syncNarrow();
    initFilms(); initLightbox();
  });
})();
